module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminampa-informacion-crear/adminampa-informacion-crear.component.scss
// module id = ./src/app/adminampa-informacion-crear/adminampa-informacion-crear.component.scss
// module chunks = main